import { createContext, useState } from "react";
import { CartBufferClient } from "./decisions-buffer/carts-buffer-client";
import {
  createDetectionBufferLoader,
  createReprojectionsBufferLoader,
  createTrackSnapshotsBufferLoader,
} from "./snapshots-buffer/buffer-loader-factory";
import {
  DetectionsBufferLoader,
  ReprojectionsBufferLoader,
  TrackSnapshotsBufferLoader,
} from "./types";

export const TracksBufferContext = createContext<
  [
    TrackSnapshotsBufferLoader,
    React.Dispatch<React.SetStateAction<TrackSnapshotsBufferLoader>>,
  ]
>([] as any);

export const CartsBufferContext = createContext<CartBufferClient>(
  {} as CartBufferClient
);

export const DetectionsBufferContext = createContext<DetectionsBufferLoader>(
  {} as DetectionsBufferLoader
);

export const ReprojectionsBufferContext =
  createContext<ReprojectionsBufferLoader>({} as ReprojectionsBufferLoader);

export function BufferControllerProvider({
  children,
}: React.PropsWithChildren) {
  const [cartsBufferClient] = useState(() => new CartBufferClient());
  const [tracksBufferClient, setTracksBufferClient] = useState(() =>
    createTrackSnapshotsBufferLoader()
  );
  const [detectionsBufferClient] = useState(() =>
    createDetectionBufferLoader()
  );
  const [projectionsBufferClient] = useState(() =>
    createReprojectionsBufferLoader()
  );

  return (
    <>
      <TracksBufferContext.Provider
        value={[tracksBufferClient, setTracksBufferClient]}
      >
        <CartsBufferContext.Provider value={cartsBufferClient}>
          <DetectionsBufferContext.Provider value={detectionsBufferClient}>
            <ReprojectionsBufferContext.Provider
              value={projectionsBufferClient}
            >
              {children}
            </ReprojectionsBufferContext.Provider>
          </DetectionsBufferContext.Provider>
        </CartsBufferContext.Provider>
      </TracksBufferContext.Provider>
    </>
  );
}
